(function() { module.exports = window["Backbone"]; }());


//////////////////
// WEBPACK FOOTER
// external "Backbone"
// module id = 2
// module chunks = 4 6 7 10 11 12 15 16 21 22 25 26 35 80